import React from "react";
import { Col } from "react-bootstrap";
import Barcode from "react-barcode";
import { MyDiv, HeadingThree, HeadingTwo, SpanTag, LabelTag, HeadingFour, StrongTag, getFormattedDeliveryTime } from "../Common/Components";
import { QRCode } from "react-qrcode-logo";

const AWF_CUST_ID = localStorage.getItem("awfCustId");

const BarcodeSection = ({ item, department, barcodeRef }) => {
  // Sub-unit stickers carry "IN101091.U1". The order number keeps its
  // legacy 235px h2; the ".U1" suffix renders below it at the smaller
  // 170px h3 size (same as the department code).
  const isUnitSticker = typeof item.order_unique_id === "string" && item.order_unique_id.includes(".");
  const dotIndex = isUnitSticker ? item.order_unique_id.indexOf(".") : -1;
  const orderNumberBase = isUnitSticker ? item.order_unique_id.slice(0, dotIndex) : item.order_unique_id;
  const orderNumberSuffix = isUnitSticker ? item.order_unique_id.slice(dotIndex) : "";
  // Legacy stickers preserve their existing total SVG width (max bar width
  // × 8-char legacy modules). Sub-unit stickers target a smaller SVG that
  // fits cleanly within the .barcodeBars 40% column so no bars get clipped
  // when html2canvas captures the sticker for the email PDF.
  const LEGACY_MODULES = 8 * 11 + 35;
  const SUB_UNIT_TARGET_PX = 680; // .barcodeBars 40% column with slack
  const isAwf = item.account_UID === AWF_CUST_ID;
  const maxBarWidth = isAwf ? 9.5 : 6.5;
  const targetPx = isUnitSticker ? SUB_UNIT_TARGET_PX : maxBarWidth * LEGACY_MODULES;
  const valueModules = (item.order_unique_id?.length || 0) * 11 + 35;
  const flashingBarWidth = Math.max(
    2.5,
    Math.min(maxBarWidth, targetPx / Math.max(valueModules, 1))
  );

  const getShortenedDepartment = () => {
    if (department === "Flashing" || !department) {
      return "";
    } else if (department === "Jobbing") {
      return department.charAt(0).toUpperCase();
    } else if (department === "Facia Gutter") {
      return "FG";
    } else if (department === "GBI") {
      return "ACC";
    } else if (department === "Roofing") {
      return "ROOF";
    } else if (department === "RV") {
      return "RV";
    } else if (department === "AWF") {
      return "AWF";
    } else {
      return department.substring(0, 2).toUpperCase();
    }
  };
  const getCount = () => {
    switch (department) {
      case "Flashing":
        return item.Order_Flashing_Count;
      case "Jobbing":
        return item.Order_Jobbing_Count;
      case "Facia Gutter":
        return item.Order_Faciagutter_Count;
      case "Cladding":
        return item.Order_Cladding_Count;
      case "GBI":
        return item.Order_GBI_Count;
      case "Roofing":
        return item.Order_Roofing_Count;
      case "RV":
        return item.Order_RV_Count;
      case "AWF":
        return item.Order_AWF_Count;
      default:
        return "";
    }
  };
  return (
    <Col md={12} xs={12} sm={12} className="mt-3">
      <HeadingThree>{department} Barcode</HeadingThree>
      <div ref={barcodeRef} className={`barcodeContainer ${item?.order_remake_checker ? "remake" : ""}`} style={{ position: 'relative' }}>
        {isUnitSticker && item.unit_position > 0 && item.total_units > 0 && (
          <div
            style={{
              position: 'absolute',
              top: item.account_UID === AWF_CUST_ID ? '270px' : '150px',
              left: '40px',
              color: '#d22530',
              fontSize: '100px',
              fontWeight: 'bold',
              zIndex: 9999,
              background: 'transparent',
            }}
          >
            Pack - {item.unit_position}/{item.total_units}
          </div>
        )}
        <MyDiv className="BarcodeHeader">
          <MyDiv className={item.account_UID === AWF_CUST_ID ? "barcodeLogoAwf" : "barcodeLogo"}>
            <img src={item.account_UID === AWF_CUST_ID ? require("../../Assets/images/awf-logo.gif") : require("../../Assets/images/EncoreSheetMetalLogo.png")} alt="logo" />
          </MyDiv>
          {department === "Flashing" || !department ? (
            <MyDiv className="barcodeBars">
              <Barcode value={item.order_unique_id} font="monospace" fontSize={14} width={flashingBarWidth} height={230} />
            </MyDiv>
           ) : null}
           {department === "Jobbing" ?
            <MyDiv className="jobbing-pieces-circles">
                <div className="jobbing-item-row">
                  <SpanTag className="jobbing-piece-circle">
                    {item.jobbing_items[0].pieces}
                  </SpanTag>

                  <LabelTag className="jobbing-item-desc">
                    {item.jobbing_items[0].description}
                  </LabelTag>
                </div>
            </MyDiv>
          : null }
        </MyDiv> 
        <MyDiv className="barcodeItems">
          <MyDiv className="BarcodeLeft" style={{ marginTop: (department === "Flashing" || !department) ? '0px' : '35px'}}>
            <MyDiv>
              <HeadingTwo>{orderNumberBase}</HeadingTwo>
              {isUnitSticker && (
                <HeadingThree style={{ margin: '0 0 20px 0', textAlign: 'left' }}>{orderNumberSuffix}</HeadingThree>
              )}
              <HeadingThree>{getShortenedDepartment()}</HeadingThree>
            </MyDiv>
            <HeadingFour>
              {item.order_delivery_address_mode === "0" ? item.order_store_delivery_city : ""}
              {item.order_delivery_address_mode === "1" ? item.order_site_delivery_city : ""}
              {item.order_delivery_address_mode === "2" ? "PickUp Order" : ""}
              {/* {item.order_delivery_address_mode === '1' ? item.order_site_delivery_city : item.order_store_delivery_city} */}
            </HeadingFour>
          </MyDiv>
          <MyDiv className="BarcodeRight">
            <ul>
              <li>
                <LabelTag>Po Number</LabelTag>
                <SpanTag>{item.order_customer_PO_number}</SpanTag>
              </li>
              <li>
                <LabelTag>Date</LabelTag>
                <SpanTag>{item.created_str?.split(" ")[0]}</SpanTag>
              </li>
              <li>
                <LabelTag>Due Date</LabelTag>
                <SpanTag> {item.order_delivery_date_str}</SpanTag>
              </li>
              <li>
                <LabelTag>Pieces</LabelTag>
                <SpanTag> {getCount()}</SpanTag>
                <MyDiv className="barcodeQRsection">
                  {department === "Flashing" || !department ? (
                    <QRCode logoHeight={32} logoWidth={32} value={item.order_unique_id} size="250" logoImage={require("../../Assets/images/encore-fav.png")} />
                  ) : (
                    <QRCode logoHeight={32} logoWidth={32} value={item.order_unique_id + getShortenedDepartment()} size="250" logoImage={require("../../Assets/images/encore-fav.png")} />
                  )}
                </MyDiv>
              </li>
              <li>
                <LabelTag>Rack</LabelTag>
                <SpanTag>{item.order_master_rack}</SpanTag>
              </li>
              <li>
                <LabelTag>Time</LabelTag>
                <StrongTag> {getFormattedDeliveryTime(item.order_delivery_time, item.order_delivery_session)} </StrongTag>
              </li>
            </ul>
          </MyDiv>
        </MyDiv>
      </div>
    </Col>
  );
};

export default BarcodeSection;
